<script>import { modals, exitBeforeEnter, transitioning } from "./store";
function parseIsOpen(modal, i) {
  if (modal.modalOptions.replace) {
    return i === $modals.length - 1 && !$transitioning;
  }
  return i <= $modals.length - 1 && !$transitioning;
}
</script>

{#if $modals.length > 0}
  <slot name="backdrop" />
{/if}

<slot>
  {#each $modals as modal, i (i)}
    <!-- normal modal -->
    <svelte:component
      this={modal.component}
      isOpen={parseIsOpen(modal, i)}
      {...modal.props}
      on:introstart={() => {
        $exitBeforeEnter = true;
      }}
      on:outroend={() => {
        $transitioning = false;
      }}
    />
  {/each}
</slot>
